export const enum ResponseStatus {
  OK = 200,
  POST_OK = 201,
  NOT_FOUND = 404,
  INTERNAL_ERROR = 500,
  UNATHORIZED = 401
}
